module.exports = __webpack_public_path__ + "static/media/roxanne-dominic.8f38b02b.jpg";